import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  searchPexelsRequest,
  searchPexelsSuccess,
  searchPexelsFailure,
} from '../slices/pexelsSlice';
import type { PexelsSearchParams, PexelsPhotosResponse, PexelsVideosResponse } from '../../components/pexels/types';
import { PROMOFLOW_BASE_API_URL } from '../../api/endPoints';

// Saga to handle Pexels search
function* searchPexelsSaga(action: PayloadAction<PexelsSearchParams>): Generator<any, void, any> {
  try {
    const { query, per_page = 20, page = 1, type, append = false } = action.payload;

    // Build API URL based on type
    const baseUrl = PROMOFLOW_BASE_API_URL.triggerUrl;
    const endpoint = type === 'photos' 
      ? `/pexels/v1/search?query=${encodeURIComponent(query)}&per_page=${per_page}&page=${page}`
      : `/pexels/videos/search?query=${encodeURIComponent(query)}&per_page=${per_page}&page=${page}`;
    
    const url = `${baseUrl}${endpoint}`;
    const response: { data: PexelsPhotosResponse | PexelsVideosResponse } = yield call(axios.get, url);
    if (response.data && response.data.success && response.data.data) {
      const mediaData = type === 'photos' 
        ? response.data.data.photos 
        : (response.data.data as any).videos || response.data.data.photos;
      
      yield put(
        searchPexelsSuccess({
          data: mediaData,
          pagination: response.data.data.pagination,
          type,
          append,
        })
      );
    } else {
      yield put(searchPexelsFailure('Failed to fetch Pexels data'));
    }
  } catch (error: any) {
    console.error('Error in searchPexelsSaga:', error);
    yield put(
      searchPexelsFailure(
        error.response?.data?.message || error.message || 'Failed to fetch Pexels data'
      )
    );
  }
}

// Root saga
export default function* pexelsSaga() {
  yield takeLatest(searchPexelsRequest.type, searchPexelsSaga);
}
